import { render, staticRenderFns } from "./comprehensiveReport.vue?vue&type=template&id=5c4ff5cd&scoped=true&"
import script from "./comprehensiveReport.vue?vue&type=script&lang=js&"
export * from "./comprehensiveReport.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveReport.vue?vue&type=style&index=0&id=5c4ff5cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ff5cd",
  null
  
)

export default component.exports